(() => {
  if (customElements.get('breathe-expert-carousel')) return;
  customElements.define('breathe-expert-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bm-expert-grid');
      this.cards = [...this.track.children];
      this.count = this.cards.length;
      this.position = this.count;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      const duplicate = card => {const copy = card.cloneNode(true); copy.dataset.clone = ''; return copy;};
      this.track.prepend(...this.cards.map(duplicate));
      this.track.append(...this.cards.map(duplicate));
      this.querySelector('[data-expert-prev]').addEventListener('click', () => this.move(this.position - 1), options);
      this.querySelector('[data-expert-next]').addEventListener('click', () => this.move(this.position + 1), options);
      this.querySelectorAll('[data-expert-dot]').forEach((dot, i) => dot.addEventListener('click', () => this.move(this.count + i), options));
      this.track.addEventListener('transitionend', event => { if(event.target === this.track && event.propertyName === 'transform') this.normalize(); }, options);
      this.resize = new ResizeObserver(() => { this.normalize(); this.render(false); });
      this.resize.observe(this.querySelector('.bm-expert-viewport'));
      this.render(false);
    }
    normalize() {
      this.position = this.count + ((this.position % this.count) + this.count) % this.count;
      this.busy = false;
      this.render(false);
    }
    move(next) {
      if(this.busy || next === this.position) return;
      this.position = next;
      this.busy = true;
      this.render(true);
      if(matchMedia('(prefers-reduced-motion: reduce)').matches) this.normalize();
    }
    render(animate) {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const width = this.cards[0].getBoundingClientRect().width;
      this.track.style.transition = animate ? 'transform .4s ease' : 'none';
      this.track.style.transform = `translateX(-${this.position * (width + gap)}px)`;
      const active = ((this.position % this.count) + this.count) % this.count;
      this.querySelectorAll('[data-expert-dot]').forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === active)));
      const visible = innerWidth > 767 ? 3 : 1;
      [...this.track.children].forEach((card, i) => {const hidden = i < this.position || i >= this.position + visible; card.setAttribute('aria-hidden', String(hidden)); card.inert = hidden;});
      this.querySelector('.bm-carousel-status').textContent = `${this.dataset.itemLabel || 'Perspective'} ${active + 1} of ${this.count}`;
    }
    disconnectedCallback() {
      this.events?.abort();this.resize?.disconnect();
      this.track?.querySelectorAll('[data-clone]').forEach(card => card.remove());
    }
  });
})();
